import type { FaireProductEntity } from "../../entity_types/product";

export const p_3ishv1sq: FaireProductEntity = {
  token: "p_3ishv1sq",
  type: "product",
  name: "Elephant Genes Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/42c21ac56a1be4c1a6771f02259c100653aa8387dbdcbcb2ae5ddd7fa2e10777.png",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/dfaac39747c3bb20049671667ad333c95581b2ee5e1e2dcf3deb47244f91b98e/1528388138.png",
    "https://cdn.faire.com/fastly/c0facc5093988f45e18aba976974a708ca3aa9558cf5846110245e219a26e2b6.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:00.207Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
